import { Component } from '@angular/core';

@Component({
  selector: 'demo-welcome',
  standalone: true,
  imports: [],
  templateUrl: './demo-welcome.component.html',
  styleUrl: './demo-welcome.component.scss',
})
export class DemoWelcomeComponent {}
